import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FileActions from "../Common/Files/FileActions";
import useFileSource from "../Common/Files/useFileSource";
import { useTranslation } from "../../context/Internationalization";
import { colors } from "../../theme/colors";

export default function UploadFilePreview({ file, compact, onRemove }) {
  const { t } = useTranslation();
  const { url, name, extension, type, previewKind } = useFileSource(file);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: compact ? "row" : "column",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
        width: "100%",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: compact ? 64 : "100%",
          height: compact ? 64 : 160,
          flexShrink: 0,
          "& > img, & > video": {
            display: "block",
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: "4px",
          },
          "& > svg": { width: compact ? 48 : 64, height: compact ? 48 : 64 },
        }}
      >
        {previewKind === "image" && url ? (
          <img src={url} alt={name} loading="lazy" />
        ) : previewKind === "video" && url ? (
          <video src={url} muted preload="metadata" />
        ) : extension === "pdf" || type === "application/pdf" ? (
          <PictureAsPdfOutlinedIcon color="primary" />
        ) : (
          <DescriptionOutlinedIcon color="action" />
        )}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, width: compact ? undefined : "100%" }}>
        <Typography variant="body2" sx={{ overflowWrap: "anywhere", mb: 0.5 }}>
          {name}
        </Typography>
        <FileActions file={file}>
          <IconButton
            type="button"
            size="small"
            aria-label={t("delete")}
            onClick={onRemove}
            sx={{
              color: "common.white",
              backgroundColor: colors.Error[500],
              "&:hover": { backgroundColor: colors.Error[700] },
            }}
          >
            <DeleteIcon />
          </IconButton>
        </FileActions>
      </Box>
    </Box>
  );
}
